///
/// EarthBrowser
///
/// Created by Matt Giger on 9/2/2024
/// Copyright (c) 2024 Geodata Labs
///

import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
export interface ShaderSourceState {
	selectedShader: string
	vertex: string
	fragment: string
	editingVertex: boolean
}

const initialState: ShaderSourceState = {
	selectedShader: "",
	vertex: "",
	fragment: "",
	editingVertex: false
}

export const shaderSourceSlice = createSlice({
	name: 'shadersource',
	initialState,
	reducers: {
		setSelectedShader: (state, action: PayloadAction<string>) => {
			state.selectedShader = action.payload
		},
		setVertex: (state, action: PayloadAction<string>) => {
			state.vertex = action.payload
		},
		setFragment: (state, action: PayloadAction<string>) => {
			state.fragment = action.payload
		},
		setEditingVertex: (state, action: PayloadAction<boolean>) => {
			state.editingVertex = action.payload
		},
	},
})

export const { setSelectedShader, setVertex, setFragment, setEditingVertex } = shaderSourceSlice.actions
export default shaderSourceSlice.reducer